import angular from 'angular';

angular
  .module('cloudX')
  .controller('DeleteWithNeverInvoiceDialogCtrl', [
    '$scope',
    '$element',
    'appMessages',
    '$translate',
    'close',
    'message',
    'btnMessage',
    'extraButtons',
    deleteWithNeverInvoiceDialogCtrl,
  ]);

function deleteWithNeverInvoiceDialogCtrl(
  $scope,
  $element,
  appMessages,
  $translate,
  close,
  message,
  btnMessage,
  extraButtons,
) {
  $scope.message = appMessages(message);
  $scope.btnMessage = btnMessage
    ? appMessages(btnMessage)
    : $translate.instant('Never invoice registration(s) again');

  $scope.extraButtons = (extraButtons || []).map(
    ({ value = null, icon = 'fa fa-ban text-danger', message = null, title = null }) => ({
      value,
      icon,
      message: message ? appMessages(message) : message,
      title,
    }),
  );

  $scope.close = function(result) {
    close(result, 500);
  };
  $scope.cancel = function() {
    close(null, 500);
  };
}
